import React, { ComponentPropsWithoutRef, FC } from 'react';
import ColorWrapper from '@styles/colors';
import { ColorFunction } from '@styles/colors/types';

interface TimelineShimmerProps extends Pick<ComponentPropsWithoutRef<'div'>, 'style'> {
  C: ColorFunction;
}

const TimelineShimmer: FC<TimelineShimmerProps> = ({ C, style }) => {
  return (
    <div
      id="shimmer"
      style={{
        width: '100%',
        height: '100%',
        backgroundColor: C('Gray/Light/3'),
        ...style,
      }}
    />
  );
};

export default ColorWrapper(TimelineShimmer);
